module.exports = __webpack_public_path__ + "img/ymc-1.5e1f958b.png";